import {HttpParams,  HttpClient,   HttpRequest} from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs/Subject';

import { ActivatedRoute } from '@angular/router';

import 'rxjs/Rx';

import { APP_CONFIG } from '../app.config';
import { Observable } from 'rxjs/Rx';
import { AuthService } from './auth.service';
import { MyDesktopService } from './mydesktop.service';

@Injectable()
export class VaultService {
    vaultAuthLogin = new Subject<any>();

    onVaultSendTemplate = new Subject();
    onVaultSyncAgent = new Subject();
    onVaultGetListing = new Subject();
    onLoginAs = new Subject();
    onVaultGetListings = new Subject();

    public path = 'vault';

    constructor(
        @Inject(APP_CONFIG) private appConfig,
        private httpClient: HttpClient,
        private authService: AuthService,
        private myDesktopService: MyDesktopService
    ) {
        const vaultLocation = localStorage.getItem('vaultLocation');

        if ( vaultLocation === 'uk' ) {
            this.path = 'vaultea';
        } else {
            this.path = 'vault';
        }
    }

    httpLogin(data: any) {
        const req = new HttpRequest(
            'POST',
            `${this.appConfig.API_ENDPOINT}/${this.path}/login`,
            data
        );

        return this.httpClient.request<any>(req)
        .map(
            (response: any) => {
            if (response.body) {
                if ( typeof response.body.status !== 'undefined') {
                    return response.body;
                }
            }

            return [];
            }
        )
        .subscribe(
            (response: any) => {
                this.vaultAuthLogin.next(response);
            },
            (response: any) => {
                this.vaultAuthLogin.next(response.error);
            }
        );
    }

    httpSendTemplate(data: any) {
        const req = new HttpRequest(
            'POST',
            `${this.appConfig.API_ENDPOINT}/${this.path}/sendtemplate`,
            data
        );

        return this.httpClient.request<any>(req)
        .map(
            (response: any) => {
            if (response.body) {
                if ( typeof response.body.status !== 'undefined') {
                    return response.body;
                }
            }

            return [];
            }
        )
        .subscribe(
            (response: any) => {
                this.onVaultSendTemplate.next(response);
            },
            (response: any) => {
                this.onVaultSendTemplate.next(response.error);
            }
        );
    }

    httpSyncAgents(id: number) {
        const req = new HttpRequest(
          'GET',
          `${this.appConfig.API_ENDPOINT}/${this.path}/sync/agents/${id}`,
        );

        return this.httpClient.request(
          req
        )
        .map(
            (response: any) => {
              if (typeof response.body !== 'undefined' && response.body != null) {
                  return response.body;
              }

              return [];
            }
        )
        .subscribe(
          (response: any) => {
            this.onVaultSyncAgent.next(response);
          },
          (response: any) => {
            this.onVaultSyncAgent.next(response.error);
          }
        );
    }

    httpGetListings(params: any = []) {
        let httpParams = new HttpParams();

        for (const p of Object.keys(params)) {
          httpParams = httpParams.append(p, params[p]);
        }

        const req = new HttpRequest(
          'GET',
          `${this.appConfig.API_ENDPOINT}/${this.path}/listings`,
          {
            params: httpParams
          }
        );

        return this.httpClient.request(
          req
        )
        .map(
            (response: any) => {
              if (typeof response.body !== 'undefined' && response.body != null) {
                  return response.body;
              }

              return [];
            }
        )
        .subscribe(
          (response: any) => {
            this.onVaultGetListings.next(response);
          },
          (response: any) => {
            this.onVaultGetListings.next(response.error);
          }
        );
    }

    httpGetListing(id: number, params: any) {
        let httpParams = new HttpParams();

        for (const p of Object.keys(params)) {
          httpParams = httpParams.append(p, params[p]);
        }

        const req = new HttpRequest(
          'GET',
          `${this.appConfig.API_ENDPOINT}/${this.path}/listing/${id}`,
          {
            params: httpParams
          }
        );

        return this.httpClient.request<any>(req)
        .map(
            (response: any) => {
                console.log(response);
              if (typeof response.body !== 'undefined' && response.body != null) {
                  return response.body;
              }

              return [];
            }
        )
        .subscribe(
          (response: any) => {
            this.onVaultGetListing.next(response);
          },
          (response: any) => {
            this.onVaultGetListing.next(response.error);
          }
        );
    }

    httpLoginAs(data: any) {
        const req = new HttpRequest(
            'POST',
            `${this.appConfig.API_ENDPOINT}/${this.path}/login-as`,
            data
        );

        return this.httpClient.request<any>(req)
        .map(
            (response: any) => {
            if (response.body) {
                if ( typeof response.body.status !== 'undefined') {
                    return response.body;
                }
            }

            return [];
            }
        )
        .subscribe(
            (response: any) => {
                this.onLoginAs.next(response);
            },
            (response: any) => {
                this.onLoginAs.next(response.error);
            }
        );
    }

    httpPaginate(data: any) {
        const req = new HttpRequest(
            'POST',
            `${this.appConfig.API_ENDPOINT}/${this.path}/paginate`,
            data
        );

        return this.httpClient.request<any>(req)
        .map(
            (response: any) => {
            if (response.body) {
                if ( typeof response.body.status !== 'undefined') {
                    return response.body;
                }
            }

            return [];
            }
        )
        .subscribe(
            (response: any) => {
                this.myDesktopService.setMyDesktops(response);
            },
            (response: any) => {
                this.myDesktopService.myDesktopApiError.next(response);
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/services/vault.service.ts